/**
 * @file paddle pilot qr code
 * @author wanzhongyun
 */

import { Popover } from 'antd';
import React, { useEffect } from 'react';
import { IHackQRCode } from './../../type';

import './style.less';


const HackFixed: React.FC<IHackQRCode> = React.memo(props => {

    const { registerLink, qrCodeUrl } = props;

    const content = <div className='popover-content'>
        <div className='popover-content-tips'>请用QQ扫码</div>
        <img className='popover-content-image' src={qrCodeUrl} alt='' />
    </div>;

    useEffect(() => {
        const footerDom = document.querySelector('.paddle-footer-container') as HTMLDivElement;
        const hoverDom = document.querySelector('.paddle-pilot-qr-code-wrapper') as HTMLDivElement;
        const scrollListenr = () => requestAnimationFrame(() => {
            if (footerDom && hoverDom) {
                const footerDomTop = footerDom.getBoundingClientRect().top;
                if (footerDomTop < 738) {
                    hoverDom.style.position = 'absolute';
                    hoverDom.style.top = 'auto';
                    hoverDom.style.bottom = '0';
                }
                else {

                    // popoverDom.style.position = 'fixed';
                    hoverDom.style.position = 'fixed';
                    hoverDom.style.bottom = 'auto';
                    hoverDom.style.top = '66%';
                }
            }
        });

        window.addEventListener('scroll', scrollListenr, false);
        return () => {
            window.removeEventListener('scroll', scrollListenr);
        }
    }, []);

    return (
        <div className='paddle-pilot-qr-code-wrapper'>
            <div className='qr-code-popover qr-code-popover-register' onClick={() => window.open(registerLink)}>
                <span className='qr-code-icon register-now' />
                <span className='qr-code-name'>立即报名</span>
            </div>
            <Popover placement="left" title='' content={content} trigger="hover" overlayClassName='qr-code-popover-wrapper'>
                <div className='qr-code-popover'>
                    <span className='qr-code-icon' />
                    <span className='qr-code-name'>加入社区</span>
                </div>
            </Popover>
        </div>
    )
});

export default HackFixed;